<script setup lang="ts">
import router from "@/router";
import { type IUniTabProp } from "../shared/tabs/UniTabs.vue";
import { useDefaultStore } from "@/store";
import { useRoute } from "vue-router";

defineProps<{
	navList: IUniTabProp[];
}>();

const emit = defineEmits(["click-menu-item", "close"]);
const isLoggedIn = ref(false);
const store = useDefaultStore();
const pathBool = ref(false);
const route = useRoute();

function toPage(name: string) {
	store.isMobileToggled = false;
	router.push({ name });
}

onMounted(() => {
	pathBool.value = !!route.path.startsWith("/fizicka-lica");
});

watch(
	() => route.path,
	async (newPath, oldPath) => {
		pathBool.value = !!route.path.startsWith("/fizicka-lica");
	},
);
</script>

<template lang="pug">
.header-mobile
	.menu
		.item(
			v-for="navItem in navList",
			:key="navItem.name",
			@click="emit('click-menu-item', navItem)"
		)
			| {{ navItem.label }}
		.item(v-if="pathBool", @click="toPage('WhyInvestPage')")
			| {{ $t("app.fearsAndMyths.dropdown.option1") }}
		.item(v-if="pathBool", @click="toPage('HowItWorksPage')")
			| {{ $t("app.fearsAndMyths.dropdown.option2") }}
		.item(v-if="pathBool", @click="toPage('InstallationProcessPage')")
			| {{ $t("app.fearsAndMyths.dropdown.option3") }}
		a.home-page-full-button(
			href="tel:+38163267266",
			aria-label="Call us",
			style="margin-top: 50px",
			@click="store.trackClickCall()"
		) {{ $t("app.callUs").toUpperCase() }}
</template>

<style lang="scss" scoped>
.header-mobile {
	display: flex;
	flex-direction: column;
	gap: 10px;
	position: fixed;
	inset: 0;
	top: 60px;
	color: var(--color-text);
	padding: 20px;
	z-index: 100;
	font-size: 20px;
	background-color: $text-color-lighter;
	height: calc(100vh - $nav-top-bar-sm - 60px);

	.menu {
		display: flex;
		flex-direction: column;
		text-align: center;
		align-items: center;
		background-color: $text-color-lighter;

		.item {
			cursor: pointer;
			font-family: "Galano Grotesque", sans-serif;

			&:hover {
				filter: brightness(1.5);
			}
		}
	}

	.action {
		display: flex;
		flex-direction: column;
		gap: 10px;
		align-items: center;
		margin-top: 30px;

		button {
			width: 200px;
		}
	}
}

@media screen and (width >= 768px) {
	.header-mobile {
		top: $nav-bottom-bar;
		height: calc(100vh - $nav-top-bar-sm - $nav-top-bar);
	}
}
</style>
